import * as React from "react";
import { useEventListener } from "@grandvisionhq/utils";
import { getCurrentBreakpoint } from "./helpers.js";
import MediaQueryContext, { BreakpointName } from "./MediaQueryContext.js";
const MediaQueryProvider = ({
  children,
  initialBreakpoint = BreakpointName.PHONE
}) => {
  const [currentBreakpoint, setBreakpoint] = React.useState(initialBreakpoint);
  React.useEffect(() => {
    setBreakpoint(getCurrentBreakpoint());
  }, []);
  const handleResize = React.useCallback(() => {
    setBreakpoint(getCurrentBreakpoint());
  }, []);
  useEventListener("resize", handleResize);
  return /* @__PURE__ */ React.createElement(MediaQueryContext.Provider, { value: { currentBreakpoint } }, children);
};
export {
  MediaQueryProvider as default
};
//# sourceMappingURL=MediaQueryProvider.js.map
